import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { FarmerDetails } from '../models/farmer-details.model';
import { BaseService } from './common/base.service';
import { TokenService } from './common/token.service';
import { VendorDetails } from '../models/vendor-details.model';

@Injectable({
  providedIn: 'root'
})
export class FarmersDetailsService extends BaseService { 
  private isAdharValidCheck = new BehaviorSubject<any>(0);
  isAdharValid = this.isAdharValidCheck.asObservable();

  constructor(private _http: HttpClient, tokenService: TokenService) {
    super(tokenService);
    this._http = _http;
  }
  updateAdharValidCheck(data: any) {
    this.isAdharValidCheck.next(data);
  }

  postFarmersData(reqBody: any): Observable<any> {
    return this._http.post(environment.apiUrl + 'PersonalDetails/Insert', reqBody)
  }
  updateFarmersData(reqBody: any): Observable<any> {
    return this._http.post(environment.apiUrl + 'PersonalDetails/Update', reqBody)
  }
  postVendersData(data:any):Observable<any>{
    return this._http.post(environment.apiUrl+'Vendor/InsertVendorPersonalDetails',data);
  }
  getVendorDetails(phoneNo):Observable<any>{
    return this._http.get<any>(`${environment.apiUrl}Vendor/GetVendorRegnDetailsByMobile?mobile=${phoneNo}`);
  }
  getVillageMatserData(): Observable<any> {
    if(window.localStorage.getItem("villageMaster")){
      return of(JSON.parse(window.localStorage.getItem("villageMaster")));
    }else{
      return this._http.get(environment.apiUrl + 'PersonalDetails/VillageMaster')
    }
  }
  getCasteMatserData(): Observable<any> {
    return this._http.get(environment.apiUrl + 'PersonalDetails/CastMaster')
  }

  getFarmerDetails(reqBody): Observable<any> {
    return this._http.post<any>(`${environment.apiUrl}PersonalDetails/GetDataByMobileNo`, reqBody);

  }
 
  uploadFile(data, mobile, uploadType){
    return this._http.post(`${environment.apiUrl}File/Upload?MobileNo=${mobile}&UploadType=${uploadType}`, data,
    // {
    //   headers: {
    //     'Content-Type': 'multipart/form-data',
    //   },
    // }
    )
  }

  uploadNewRegFile(data, mobile, uploadType){
    return this._http.post(`${environment.apiUrl}File/UploadVendorRegDocs?MobileNo=${mobile}&UploadType=${uploadType}`, data)
  }

  vendorRegFileDelete(reqBody){
    return this._http.post(`${environment.apiUrl}Vendor/VendorRegFileDelete`, reqBody)
  }

  getBase64Image(path){
    return this._http.get(`${environment.apiUrl}File/GetFileAsBase64/${path}`)
  }

  getTargetStatus(reqBody){
     return this._http.post<any>(`${environment.apiUrl}FarmerApplication/GetTargetStatus?AppId=${reqBody.AppId}&VillageCode=${reqBody.VillageCode}&MI=${reqBody.MI}&Pond=${reqBody.Pond}&Solar=${reqBody.Solar}&LandId=${reqBody.LandId}&ProgramId=${reqBody.ProgramId}&ApplyArea=${reqBody.ApplyArea}&SchemeCode=${reqBody.SchemeCode}&UHBVNAppId=${reqBody.UHBVNAppId}`, {responseType: 'text'})
  }

  getVillageBasedOnFarmerId(farmerId): Observable<any> {
    return this._http.get<any>(`${environment.apiUrl}FarmerApplication/GetVillageBasedOnFarmerId?FarmerId=${farmerId}`);
  }

  validateAadhar(reqBody:any): Observable<any> {
    return this._http.post<any>(`${environment.apiUrl}External/GenerateAadharOTP`, reqBody);
    // return this._http.get<any>(`http://cada.hartron.io:98/api/External/GenerateAadharOTP?AadharNo=${aadharNumber}`);
  }

  validatePPID(FID){
    return this._http.get<any>(`${environment.apiUrl}External/GenerateAadharOTP?AadharNo=${FID}`);
    // return this._http.post<any>(`http://cada.hartron.io:98/api/External/OTPRequestForFID?FID=${FID}`, {responseType: 'text'});
  }

  getFamilyIdByUID(UID, farmerId){
    farmerId = farmerId == null ? '' : farmerId;
    return this._http.post<any>(`${environment.apiUrl}External/GetFamilyIdByUID?UID=${UID}&FarmerId=${farmerId}`, {responseType: 'text'});
    // return this._http.post<any>(`http://cada.hartron.io:98/api/External/GetFamilyIdByUID?UID=${UID}&FarmerId=${farmerId}`, {responseType: 'text'});
  }

  validateOTP(aadharNumber, otp, memberId){
    memberId = memberId == null ? '' : memberId;
    return this._http.get<any>(`${environment.apiUrl}External/ValidateAadharOTP?AadharNo=${aadharNumber}&OTP=${otp}&MemberId=${memberId}`);
    // return this._http.get<any>(`http://cada.hartron.io:98/api/External/ValidateAadharOTP?AadharNo=${aadharNumber}&OTP=${otp}&MemberId=${memberId}`);
  }

  OTPRequestforMEMID(MID){ 
    return this._http.post<any>(`${environment.apiUrl}External/OTPRequestforMEMID?MemberId=${MID}`, {responseType: 'text'});
  }

  verifyOTPRequestForMID(FID, memberId, otp){ 
    FID = FID == null ? '' : FID;
    memberId = memberId == null ? '' : memberId;

    return this._http.post<any>(`${environment.apiUrl}External/VerifyOTPRequestForMID?FID=${FID}&MemberId=${memberId}&OTP=${otp}`, {responseType: 'text'});
    // return this._http.post<any>(`http://cada.hartron.io:98/api/External/VerifyOTPRequestForMID?FID=${FID}&MemberId=${memberId}&OTP=${otp}`, {responseType: 'text'});
  }

  getVerifyPPPID(farmerId, familyId){ 
    return this._http.get<any>(`${environment.apiUrl}FarmerApplication/GetVerifyPPPID?FarmerId=${farmerId}&PPPID=${familyId}`);
  }

  getUHBVNAppForJE(userId){ 
    return this._http.get<any>(`${environment.apiUrl}FarmerApplication/GetUHBVNAppForJE?userid=${userId}`);
  }

  submitOwnMIFarmerDetailPV(reqBody:any):any {
    return this._http.post(`${environment.apiUrl}FarmerApplication/SubmitOwnMIFarmerDetailPV`, reqBody);
  }

  submitUHBVN_Letter_MI_PV(reqBody:any):any {
    return this._http.post(`${environment.apiUrl}FarmerApplication/SubmitUHBVN_Letter_MI_PV`, reqBody);
  }

  getOwnMIFarmerDetailPVByAppId(appId){ 
    return this._http.get<any>(`${environment.apiUrl}FarmerApplication/GetOwnMIFarmerDetailPVByAppId?AppId=${appId}`);
  }

  getUHBVN_Letter_MI_PV(appId){ 
    return this._http.get<any>(`${environment.apiUrl}FarmerApplication/GetUHBVN_Letter_MI_PV?AppId=${appId}`);
  }

  insertStatePhysicalFinancialTarget(reqBody){ 
    return this._http.post<any>(`${environment.apiUrl}External/InsertStatePhysicalFinancialTarget`, reqBody);
  }
  
  getStatePhysicalFinancialTarget(){ 
    return this._http.get<any>(`${environment.apiUrl}External/GetStatePhysicalFinancialTarget`);
  }
  
  postStatePhysicalFinancialTarget(){ 
    return this._http.post<any>(`${environment.apiUrl}External/PostStatePhysicalFinancialTarget`, {});
  }

  insertDistrictPhysicalFinancialTarget(reqBody){ 
    return this._http.post<any>(`${environment.apiUrl}External/insertDistrictPhysicalFinancialTarget`, reqBody);
  }
  
  getDistrictPhysicalFinancialTarget(){ 
    return this._http.get<any>(`${environment.apiUrl}External/GetDistrictPhysicalFinancialTarget`);
  }

  postDistrictPhysicalFinancialTarget(){ 
    return this._http.post<any>(`${environment.apiUrl}External/PostDistrictPhysicalFinancialTarget`, {});
  }
  
  getDistrictPhysicalFinancialAchievement(){ 
    return this._http.get<any>(`${environment.apiUrl}External/GetDistrictPhysicalFinancialAchievement`);
  }

  postDistrictPhysicalFinancialAchievement(){ 
    return this._http.post<any>(`${environment.apiUrl}External/PostDistrictPhysicalFinancialAchievement`, {});
  }

  getDistrictOtherSourceAchievement(){ 
    return this._http.get<any>(`${environment.apiUrl}External/GetDistrictOtherSourceAchievement`);
  }

  getVendorRegDocTypeMaster(id){ 
    return this._http.get<any>(`${environment.apiUrl}vendor/GetVendorRegDocTypeMaster?Id=${id}`);
  }

  getVendorRegStatusMaster(){ 
    return this._http.get<any>(`${environment.apiUrl}vendor/GetVendorRegStatusMaster`);
  }

  postDistrictOtherSourceAchievement(){ 
    return this._http.post<any>(`${environment.apiUrl}External/PostDistrictOtherSourceAchievement`, {});
  }
  getUHBVNAppByXEN(userId){ 
    return this._http.get<any>(`${environment.apiUrl}FarmerApplication/GetUHBVNAppByXEN?userid=${userId}`);
  }

  getEmailOTPVendorReg(reqBody){ 
    return this._http.post<any>(`${environment.apiUrl}Vendor/GetEmailOTPVendorReg`, reqBody);
  }

  getMobileOTPVendorReg(reqBody){ 
    return this._http.post<any>(`${environment.apiUrl}Vendor/GetOTPVendorReg`, reqBody);
  }

  emailOTPValidationVendorReg(reqBody){ 
    return this._http.post<any>(`${environment.apiUrl}Vendor/EmailOTPValidationVendorReg`, reqBody);
  }

  mobileOTPValidationVendorReg(reqBody){ 
    return this._http.post<any>(`${environment.apiUrl}Vendor/OTPValidationVendorReg`, reqBody);
  }

  insertVendorRegAttachments(reqBody) {
    return this._http.post<any>(`${environment.apiUrl}Vendor/InsertVendorRegAttachments`, reqBody);
  }
}
